import axios from "axios";
import { getEnvironment } from "../utils/getEnvironment";

const environment = getEnvironment();

interface MessageRaw {
    key: string;
    isUser: boolean;
    message: string;
    created: Date;
    viewed?: Date;
    image?: string | null;
}

interface MessageListResponse {
    messages: MessageRaw[];
    total: number;
    start: number;
    count: number;
}

export default class Message {
    key: string;
    isUser: boolean;
    message: string;
    created: Date;
    image?: string | null;
    viewed?: Date;

    constructor(data: MessageRaw) {
        this.key = data.key;
        this.isUser = data.isUser;
        this.message = data.message;
        this.created = data.created;
        this.viewed = data.viewed;
        this.image = data.image;
    }

    public static readonly list = async (
        uuid: string,
        brand: string,
        user: string,
        start: number,
        count: number
    ): Promise<{ messages: Message[]; total: number }> => {
        try {
            const { data } = await axios.get<MessageListResponse>(
                environment.api_url + "/" + brand + "/chat/" + user + "/list",
                {
                    headers: {
                        "User-Token": uuid,
                    },
                    timeout: 10000,
                    params: { start, count },
                }
            );

            return {
                messages: data.messages.map((x) => new Message(x)),
                total: data.total,
            };
        } catch (err) {
            console.error("Failed to fetch messages:", err);
            return { messages: [], total: 0 };
        }
    };

    public static readonly send = async (
        uuid: string,
        brand: string,
        user: string,
        message: string,
        image?: string | null
    ) => {
        return axios.post(
            environment.api_url + "/" + brand + "/chat/" + user,
            {
                message,
                image,
            },
            {
                headers: {
                    "User-Token": uuid,
                },
            }
        );
    };

    public static readonly viewed = async (
        uuid: string,
        brand: string,
        user: string,
        message: string
    ) =>
        axios.put(
            environment.api_url + "/" + brand + "/chat/" + user + "/" + message,
            undefined,
            {
                headers: {
                    "User-Token": uuid,
                },
                timeout: 5000,
            }
        );
}
